<base-modal-component class="base-modal" (onConfirm)="save()">
    <select class="form-control selectx"
            [compareWith]="compareBeans"
            [(ngModel)]="selectedCompany">
        <option *ngFor="let company of companies" [ngValue]="company">
            {{company.name}}
        </option>
    </select>
</base-modal-component>
